class CollectionsBrowser {
  constructor(container) {
    this.container = container;
    this.section = container.closest(".section-list-collections");
    this.grid = this.section
      ?.querySelector("[data-collection-card]")
      ?.closest(".collections-grid");
    this.cards = this.grid
      ? Array.from(this.grid.querySelectorAll("[data-collection-card]"))
      : [];
    this.search = container.querySelector("[data-collections-search]");
    this.sort = container.querySelector("[data-collections-sort]");
    this.filters = Array.from(
      container.querySelectorAll("[data-collections-filter]")
    );
    this.count = container.querySelector("[data-collections-count]");
    this.countLabel = container.querySelector("[data-collections-count-label]");
    this.sortLabel = container.querySelector("[data-collections-sort-label]");
    this.empty = this.section?.querySelector("[data-collections-empty]");
    this.reset = this.section?.querySelector("[data-collections-reset]");
    this.activeFilter = "all";

    if (!this.grid || this.cards.length === 0) return;

    this.bind();
    this.apply();
  }

  bind() {
    this.search?.addEventListener("input", () => this.apply());
    this.sort?.addEventListener("change", () => this.apply());
    this.reset?.addEventListener("click", () => this.resetControls());

    this.filters.forEach((filter) => {
      filter.addEventListener("click", () => {
        this.activeFilter = filter.dataset.collectionsFilter || "all";
        this.filters.forEach((item) => {
          const isActive = item === filter;
          item.classList.toggle("is-active", isActive);
          item.setAttribute("aria-pressed", isActive ? "true" : "false");
        });
        this.apply();
      });
    });
  }

  syncAvailableFilters() {
    this.filters.forEach((filter) => {
      const value = filter.dataset.collectionsFilter;
      if (!value || value === "all") return;

      const hasMatchingCard = this.cards.some((card) =>
        this.getCategories(card).includes(value)
      );
      filter.hidden = !hasMatchingCard;
    });
  }

  apply() {
    this.refreshCards();
    this.syncAvailableFilters();
    this.sortCards();

    const query = (this.search?.value || "").trim().toLowerCase();
    let visibleCount = 0;

    this.cards.forEach((card) => {
      const matchesSearch =
        !query || (card.dataset.search || "").includes(query);
      const matchesFilter =
        this.activeFilter === "all" ||
        this.getCategories(card).includes(this.activeFilter);
      const isVisible = matchesSearch && matchesFilter;

      card.hidden = !isVisible;
      if (isVisible) visibleCount += 1;
    });

    if (this.count) this.count.textContent = String(visibleCount);
    if (this.countLabel)
      this.countLabel.textContent =
        visibleCount === 1 ? "collection" : "collections";
    if (this.sort && this.sortLabel) {
      this.sortLabel.textContent =
        this.sort.options[this.sort.selectedIndex]?.text || "";
    }
    if (this.empty) this.empty.hidden = visibleCount !== 0;
  }

  sortCards() {
    if (!this.sort) return;

    const sortValue = this.sort.value;
    const sortedCards = [...this.cards].sort((a, b) => {
      if (sortValue === "products-desc" || sortValue === "products-asc") {
        const result =
          Number(a.dataset.products || 0) - Number(b.dataset.products || 0);
        return sortValue === "products-desc" ? result * -1 : result;
      }

      if (sortValue === "date-desc" || sortValue === "date-asc") {
        const result =
          Number(a.dataset.published || 0) - Number(b.dataset.published || 0);
        return sortValue === "date-desc" ? result * -1 : result;
      }

      const result = (a.dataset.title || "").localeCompare(
        b.dataset.title || "",
        undefined,
        {
          sensitivity: "base",
        }
      );
      return sortValue === "title-desc" ? result * -1 : result;
    });

    sortedCards.forEach((card) => this.grid.appendChild(card));
  }

  getCategories(card) {
    return (card.dataset.categories || "").split(" ").filter(Boolean);
  }

  refreshCards() {
    this.cards = this.grid
      ? Array.from(this.grid.querySelectorAll("[data-collection-card]"))
      : [];
  }

  resetControls() {
    if (this.search) this.search.value = "";
    this.activeFilter = "all";

    this.filters.forEach((filter) => {
      const isActive = filter.dataset.collectionsFilter === "all";
      filter.classList.toggle("is-active", isActive);
      filter.setAttribute("aria-pressed", isActive ? "true" : "false");
    });

    this.apply();
  }
}

const initCollectionsBrowsers = (root = document) => {
  root.querySelectorAll("[data-collections-browser]").forEach((container) => {
    if (container.dataset.collectionsBrowserInitialized === "true") return;
    container.dataset.collectionsBrowserInitialized = "true";
    new CollectionsBrowser(container);
  });
};

document.addEventListener("DOMContentLoaded", () => initCollectionsBrowsers());
document.addEventListener("shopify:section:load", (event) =>
  initCollectionsBrowsers(event.target)
);
